export default __webpack_public_path__ + "static/media/error-banner.4d9c5c19.svg";